import { ViewModel,View } from "binder"
import { FormBuilderComponent } from "src/formBuilder/structure/components";
import { FormBuilderElement, IFormBuilderElementVisitor } from "src/formBuilder/structure/element";
import { StringPropertyType } from "src/formBuilder/structure/propertyTypes/propetyTypes";
import  { SpanView } from "./span-view"



export class SpanComponent extends FormBuilderComponent{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.name = 'Span';
        this.addProperty("Text","",new StringPropertyType(this),"Text",true);
    }
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    CreateInternal(parent:ViewModel):FormBuilderElement{
        let result = new SpanElement(parent);
        return result;
    }
        
}

export class SpanElement extends FormBuilderElement{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new SpanView();
    }
    public getTypeId(): string {
        return "VM-32CA94F1-C9A7-410D-8D7E-6330C0CA5EE8"
    }
    public set Text(v: string) { this._Text = v; } public get Text(): string { return this._Text;} private _Text: string;
    
    Accept(visitor: IFormBuilderElementVisitor, parameter: object): object {
        return visitor.VisitSpan(this,parameter);
    }
    
}
